import { http } from 'services';

// ## Instance - list subscriptions
// curl "http://192.168.0.20:3000/instance/subscriptions"
export function getSubscriptions(cbSuccess, cbError) {
  http.get(
    'instance/subscriptions',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - get subscription by id
// curl "http://192.168.0.20:3000/instance/subscriptions/2"
export function getSubscriptionDetails(subscriptionID, cbSuccess, cbError) {
  http.get(
    `instance/subscriptions/${subscriptionID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - list subscription invoices
// curl "http://192.168.0.20:3000/instance/subscriptions/2/invoices"
export function getSubscriptionInvoices(subscriptionID, cbSuccess, cbError) {
  http.get(
    `instance/subscriptions/${subscriptionID}/invoices`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - get subscription invoice by id
// curl "http://192.168.0.20:3000/instance/subscriptions/2/invoices"
export function getSubscriptionInvoice(subscriptionID, invoiceID, cbSuccess, cbError) {
  http.get(
    `instance/subscriptions/${subscriptionID}/invoices/${invoiceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getSubscribedPlanSummarized(cbSuccess, cbError) {
  http.get(
    'instance/subscribed-plan/summarized',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Plan purchase - Get subscription options
// curl "http://192.168.0.18:3000/instance/plan-purchase/subscription-options"
export function getPlanPurchaseSubscriptionOptions(cbSuccess, cbError) {
  http.get(
    'instance/plan-purchase/subscription-options',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}


// ## Instance - Plan purchase - Check subscription constraints
// curl -X "POST" "http://192.168.0.18:3000/instance/plan-purchase/check-constraints"

// ## Instance - Plan purchase - Save subscription selection
// curl -X "POST" "http://192.168.0.18:3000/instance/plan-purchase/subscription-selection"

export function savePlanPurchaseSubscriptionSelection(payload, cbSuccess, cbError) {
  http.post(
    'instance/plan-purchase/subscription-selection',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Plan purchase - Get final review
// curl "http://192.168.0.18:3000/instance/plan-purchase/review"
export function getPlanPurchaseGetFinalReview(cbSuccess, cbError) {
  http.get(
    'instance/plan-purchase/review',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Plan purchase - Checkout
// curl -X "POST" "http://192.168.0.18:3000/instance/plan-purchase/checkout"

export function processPlanPurchaseCheckout(payload, cbSuccess, cbError) {
  http.post(
    'instance/plan-purchase/checkout',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-instance/api-instance-subscriptions.js